import Link from 'next/link';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  url: string | null;
  onClick?: () => void;
}

export default function MobileMenuItemWrapper({ children, className, onClick, url }: Props) {
  return url ? (
    <Link href={url} className={className}>
      {children}
    </Link>
  ) : (
    <button className={className} onClick={onClick} type="button">
      {children}
    </button>
  );
}
